// extracted by mini-css-extract-plugin
export default {"wrap":"Comments_wrap__IUEgJ","textarea":"Comments_textarea__xmUsx"};